import moment from 'moment';
import NewsController from './NewsController';
import { Settings } from './Settings';

document.addEventListener('DOMContentLoaded', () => {
  moment.locale(Settings.language());
  $('#CurrentMonth').html(moment().format('MMMM YYYY'));
  const controller = new NewsController();
  controller.Init();
});
